import React from 'react';

import p from 'prop-types';

import Varchar from 'ROOT/src/components/listEditableFields/varchar/varchar';
import Enum from '../listViewFields/Enum';
import Multienum from 'ROOT/src/components/listViewFields/Multienum';
import Currency from 'ROOT/src/components/listViewFields/Currency';
import CurrencyId from 'ROOT/src/components/listViewFields/CurrencyId';
import NameCallback from 'ROOT/src/components/listViewFields/NameCallback';
import Name from '../listViewFields/Name';
import Phone from 'ROOT/src/components/listViewFields/Phone';
import Url from 'ROOT/src/components/listViewFields/Url';
import Date from 'ROOT/src/components/listViewFields/Date';
import Datetime from 'ROOT/src/components/listViewFields/Datetime';
import Relate from 'ROOT/src/components/listViewFields/Relate';
import FileName from '../listViewFields/FileName';
import FileNameCallBack from 'ROOT/src/components/listViewFields/FileNameCallBack';
import PerilIcon from './PerilIcon';

import sAction from 'sAction';

import NewListViewField_orig from 'ROOT/src/components/list/NewListViewField';

export default class NewListViewField extends NewListViewField_orig {
    render() {
        const row = this.props.row;
        const line = this.props.line;
        const editModule = this.props.editModule;
        const modul = this.props.modul;
        const grModule = row.def.get('fieldModule');
        const key = row.get('key');
        const listType = this.props.listType;
        const type = row.def.get('type');
        const index = this.props.index;
        const rowIndex = this.props.rowIndex;
        const bcColor = this.props.bcColor;
        const icon = this.props.icon;
        const prefix = this.props.prefix;
        const disabled = this.props.disabled;
        const inRightPanel = this.props.prefix.includes('rightPanel');
        const isWidget = this.props?.isWidget;

        const allowedModulesDownloadDialog = [
            'aon_portal_documents',
            'aon_event_response_files',
            'aon_notices_and_fixes',
        ];

        let lineRender = null;
        let extraClass = '';
        if (line.get('actEdit') && type != 'multienum') {
            let fieldType = type;
            if (type == 'id' && row.def.get('name') == 'currency_id') {
                fieldType = 'currency_id';
            }
            const F = sAction.listFields[fieldType] || sAction.listFields['varchar'];
            let fieldData;
            if (type == 'parent') {
                fieldData = {
                    def: row.def,
                    value: line.get('value'),
                    name: row.def.get('name'),
                    editModule,
                    recordId: this.props.uuid,
                    module: line.get('module') || null,
                };
            } else {
                fieldData = {
                    def: row.def,
                    value: line.get('value'),
                    name: row.def.get('name'),
                    editModule,
                    recordId: this.props.uuid,
                };
            }
            const editableField = (
                <F
                    way={prefix}
                    listField={true}
                    data={fieldData}
                    rowIndex={rowIndex}
                    recordIndex={index}
                />
            );
            let classes = '';
            if (type == 'currency') {
                classes = 'listViewCellRight';
            }
            return (
                <div className={'newListViewLine newListEditableField ' + classes + (isWidget ? ' widget' : '')}>
                    {editableField}
                </div>
            );
        }
        if (
            (row.key == 'NAME' || row.key == 'name' ||
      row.key == 'full_name' || row.key == 'FULL_NAME') &&
      (modul == row.def.get('fieldModule') ||
        grModule == 'Activities' ||
        grModule == 'History')
        ) {
            var Field = NameCallback;

            let value = line.get('value');
            if ( ! value || ! value.trim()) {
                value = '____';
            }

            let disMod = grModule;
            if (grModule == 'Activities' || grModule == 'History') {
                disMod = modul;
            }

            if (listType == 'popup') {
                return (
                    <Field
                        module={disMod}
                        value={value}
                        callback={() =>
                            this.callback({id: line.get('id'), name: line.get('value')})
                        }
                        extraClass={extraClass}
                    />
                );
            } else if (listType == 'rightPanelQuotes') {
                return (
                    <Field
                        module={disMod}
                        value={value}
                        callback={() =>
                            this.callback({id: line.get('id'), name: line.get('value')})
                        }
                        extraClass="hrefEffect"
                    />
                );
            } else if (disMod === 'acm_CampaignsAction') {
                const [title, link] = line.get('value').split('::', 2);
                return (
                    <Name
                        value={title}
                        customHref={link}
                        disabled={true}
                    />
                );
            } else {
                var Field = Name;
                var rightPanelData = {};
                if (listType == 'subpanel' && ! inRightPanel) {
                    rightPanelData = {
                        'reloadList': prefix,
                    };
                }

                return (
                    <Field
                        module={disMod}
                        id={line.get('id')}
                        callback={(ev) => {
                            if (listType === 'subpanel' && ev) {
                                ev.target.closest('.subpanelContainer').classList.remove('maxSize');
                            }
                            sAction.setStorage('listViewSearchIndex', index);
                        }}
                        eyeCallBack={() => {
                            if (!allowedModulesDownloadDialog.includes(this.props.modul) ||
                                !this.props.extraData) {
                                sAction.setStorage('listViewSearchIndex', index);
                                sAction.rightPanelDetail(disMod, line.get('id'), rightPanelData);
                            }
                        }}
                        value={value}
                        onClick={(e) => {
                            if (allowedModulesDownloadDialog.includes(this.props.modul) &&
                                this.props.extraData) {
                                const fileData = {
                                    moduleOrg: this.props.modul,
                                    module: 'FieldFile',
                                    id: this.props.extraData.get('value').split('::')[0],
                                    name: this.props.extraData.get('value').split('::')[1],
                                    documentId: line.get('id'),
                                };
                                sAction.downloadFile(fileData);
                            }
                            this.actEdit(e);
                        }}
                        disabled={disabled}
                        disableLink={allowedModulesDownloadDialog.includes(this.props.modul)}
                        inRightPanel={inRightPanel}
                        forceRightPanel={this.props.forceRightPanel}
                        target={this.props.target}
                    />
                );
            }
        } else if (row.get('def').get('convertToIcon')) {
            switch (row.get('def').get('name')) {
                case 'peril':
                    lineRender = <PerilIcon value={line.get('value')} />;
                    break;
                default:
                    console.warn('[ WARN ] Unknown convertToIcon filed. Define icon conversion.', row.get('def').get('name'));
                    lineRender = <span title={line.get('value')}>{line.get('value')}</span>;
            }
        } else if (row.get('def').get('convertFileSize')) {
            const fileSize = sAction.convertFileSize(line.get('value'));
            lineRender = <span title={fileSize}>{fileSize}</span>;
        } else if (row.key.toLowerCase() == 'document_name') {
            let value = line.get('value');
            if ( ! value || ! value.trim()) {
                value = '____';
            }
            if (listType == 'popup') {
                Field = NameCallback;
                return (
                    <Field
                        value={value}
                        callback={() =>
                            this.callback({id: line.get('id'), name: line.get('value')})
                        }
                        extraClass={extraClass}
                    />
                );
            } else {
                return (
                    <FileName
                        module={row.def.get('fieldModule')}
                        value={value}
                        id={line.get('id')}
                        extraClass="hrefEffect"
                        onGetFile={(data) => sAction[data.sActionFunction || 'downloadFile'](data)}
                        index={index}
                    />
                );
            }
        } else if (row.key == row.def.get('fieldModule').toUpperCase() + '|NAME') {
            let value = line.get('value');
            if ( ! value || ! value.trim()) {
                value = '____';
            }
            if (line.get('id') !== '' && line.get('id') !== null) {
                return (
                    <Name
                        module={row.def.get('fieldModule')}
                        id={line.get('id')}
                        value={value}
                        eyeCallBack={() => {
                            sAction.setStorage('listViewSearchIndex', index);
                            sAction.rightPanelDetail(row.def.get('fieldModule'), line.get('id'), rightPanelData);
                        }}
                    />
                );
            } else {
                lineRender = line.get('value');
            }
        } else if (type === 'url') {
            return <Url value={line.get('value')} />;
        } else if (type == 'currency') {
            let curVal = line.get('value');
            if (curVal.indexOf('xxx') === -1) {
                curVal = sAction.formatNumber(line.get('value'));
            }
            return (
                <Currency
                    value={curVal}
                    currency={line.get('currency_id')}
                    currencies={sAction.currencies}
                    onClick={(e) => this.actEdit(e)}
                />
            );
        } else if (type === 'enum') {
            return (
                <Enum
                    option={sAction.app_strings[row.def.get('options')]}
                    value={line.get('value')}
                    bcColor={bcColor}
                    icon={icon}
                    extraClass={extraClass}
                    onClick={(e) => this.actEdit(e)}
                />
            );
        } else if (type === 'AcmDynamicEnum') {
            let dynEnumOptions = {};
            if (sAction.app_strings['dynamicEnum'] && row.def && row.def.get('options') && sAction.app_strings['dynamicEnum'][row.def.get('options')]) {
                dynEnumOptions = sAction.app_strings['dynamicEnum'][row.def.get('options')];
            } else {
                console.log('Chybějící dynamický číselník');
            }
            return (
                <Enum
                    option={dynEnumOptions}
                    value={line.get('value')}
                    bcColor={bcColor}
                    extraClass={extraClass}
                    onClick={(e) => this.actEdit(e)}
                />
            );
        } else if (type === 'multienum') {
            return (
                <Multienum
                    options={sAction.app_strings[row.def.get('options')]}
                    value={line.get('value')}
                    bcColor={bcColor}
                    extraClass={extraClass}
                    onClick={(e) => this.actEdit(e)}
                />
            );
        } else if (type == 'date') {
            return (
                <Date
                    value={sAction.dateFormat(line.get('value'))}
                    onClick={(e) => this.actEdit(e)}
                />
            );
        } else if (type == 'datetime' || type == 'datetimecombo') {
            return (
                <Datetime
                    value={sAction.dateFormat(line.get('value'))}
                    onClick={(e) => this.actEdit(e)}
                />
            );
        } else if (type == 'relate') {
            return <Relate value={line} onClick={(e) => this.actEdit(e)} />;
        } else if (row.def.get('name') == 'currency_id') {
            return (
                <CurrencyId
                    value={line.get('value')}
                    currencies={sAction.currencies}
                    onClick={(e) => this.actEdit(e)}
                />
            );
        } else if (type == 'parent') {
            return <Relate value={line} onClick={(e) => this.actEdit(e)} />;
        } else if (type == 'bool') {
            const isActive =
        line.get('value') == '1' ?
            sAction.translate('LBL_STATUS_ACTIVE_LIST') :
            sAction.translate('LBL_STATUS_INACTIVE_LIST');
            lineRender = <span title={isActive}>{isActive}</span>;
        } else if (type == 'icon') {
            lineRender = (
                <span className="iconListviewContainer">
                    <div className={'icon-' + line.get('module')} />
                </span>
            );
        } else if (type == 'image') {
            lineRender = (
                <div style={{overflow: 'hidden', textOverflow: 'ellipsis'}} className="link" onClick={() => sAction.popup('image', {url: sAction.param.files+'image/'+line.get('value')})}>
                    {line.get('value')}
                </div>
            );
        } else if (type == 'phone') {
            lineRender = (
                <a href={'callto:'+line.get('value')}>{line.get('value')}</a>
            );
        } else if (
            type === 'float' ||
        type === 'double' ||
        type === 'decimal'
        ) {
            extraClass = 'listViewCellRight';
            lineRender = <span title={line.get('value')}>{sAction.formatNumber(line.get('value'))}</span>;
        } else if (
            type === 'int' ||
        type === 'integer'
        ) {
            extraClass = 'listViewCellRight';
            lineRender = <span title={line.get('value')}>{sAction.formatNumber(line.get('value'), 0)}</span>;
        } else if (type === 'button') {
            // tlacitko v listu, label je ve formatu LBL_TLACITKO|nazevFunkce
            if (line && line.get('value')) {
                const [buttonText, buttonFunction] = line.get('value').split('|');
                lineRender = (<a title={sAction.translate(buttonText)}
                    onClick={() => sAction[buttonFunction]({id: this.props.uuid})}>
                    <span className="listButton">
                        {sAction.translate(buttonText)}
                    </span>
                </a>);
            }
        } else if (type === 'file') {
            let value = line.get('value');
            if ( ! value || ! value.trim()) {
                value = '____';
            }
            return (
                <FileName
                    module={row.def.get('fieldModule')}
                    value={value}
                    id={line.get('id')}
                    extraClass="hrefEffect"
                    isWidget={true}
                    prefix={prefix}
                    onGetFile={(data) => {
                        const fileData = data;
                        fileData.moduleOrg = data.module;
                        fileData.module = 'FieldFile';
                        sAction[data.sActionFunction || 'downloadFile'](fileData);
                    }}
                    index={index}
                />
            );
        } else if (type === 'html') {
            const cleanText = line.get('value').replace(/(<br([^>]+)>)/ig, '\u2000').replace(/(<([^>]+)>)/ig, '');
            lineRender = <span title={cleanText}>{cleanText}</span>;
        } else {
            if (key.toLowerCase() === 'email1') {
                lineRender = <a title={line.get('value')} onClick={() => sAction.openEmailPopup(
                    {
                        to_addrs: line.get('value'),
                        parent_id: this.props.getIdByIndex(index),
                        parent_name: this.props.getPropertyValueByIndex(index, 'NAME'),
                        parent_type: modul,
                    },
                )}>{line.get('value')}</a>;
            } else {
                lineRender = <span title={line.get('value')}>{line.get('value')}</span>;
            }
        }
        return (
            <div
                className={'newListViewLine ' + extraClass + (isWidget ? ' widget' : '')}
                onClick={(e) => this.actEdit(e)}
            >
                {lineRender}
            </div>
        );
    }
}
NewListViewField.propTypes = {
    row: p.object,
    line: p.object,
    modul: p.string,
};
